import { useEffect } from "react";
import { createBrowserRouter, Navigate, Outlet, RouterProvider, ScrollRestoration } from "react-router";

import { RouterErrorBoundary } from "./components/ErrorBoundary";
import Lightbox from "./components/Lightbox";
import Toaster from "./components/Toaster";
import Authentication from "./layouts/Authentication";
import Layout from "./layouts/Layout";
import { activityRoutes } from "./pages/ActivityPage";
import { destinationsRoutes } from "./pages/DestinationsPage";
import { importRoutes } from "./pages/import/routes";
import { magicLinksRoutes } from "./pages/MagicLinksPage";
import { modelsRoutes } from "./pages/ModelsPage";
import { overviewRoutes } from "./pages/OverviewPage";
import { recipientsRoutes } from "./pages/RecipientsPage";
import { settingsRoutes } from "./pages/SettingsPage";
import { sourcesRoutes } from "./pages/SourcesPage";
import TeapotPage from "./pages/TeapotPage";
import { webhooksRoutes } from "./pages/WebhooksPage";
import { setQueryErrorHandler } from "./providers/QueryProvider";
import { useToast } from "./providers/ToastProvider";

const AppContent = () => {
  const { addToast } = useToast();

  useEffect(() => {
    setQueryErrorHandler((error) => {
      addToast({
        kind: "ERROR",
        message: error.error.message,
      });
    });
  }, [addToast]);

  return (
    <>
      <Toaster />
      <Lightbox />
      <Authentication>
        <Layout>
          <Outlet />
        </Layout>
      </Authentication>
      <ScrollRestoration />
    </>
  );
};

const router = createBrowserRouter([
  {
    path: "/*",
    element: <AppContent />,
    errorElement: <RouterErrorBoundary />,
    children: [
      overviewRoutes,
      activityRoutes,
      sourcesRoutes,
      modelsRoutes,
      recipientsRoutes,
      destinationsRoutes,
      magicLinksRoutes,
      webhooksRoutes,
      settingsRoutes,
      importRoutes,
      // Teapot easter egg
      {
        path: "teapot",
        element: <TeapotPage />,
      },
      // Default redirect
      {
        path: "*",
        element: <Navigate to="/overview" replace />,
      },
    ],
  },
]);

const App = () => {
  return <RouterProvider router={router} />;
};

export default App;
